import { RefObject, useEffect, useState } from 'react';

export function useScrollHeightObserver<T extends HTMLElement>(
    elementRef: RefObject<T>,
    enabled: boolean = true
): number {
    const [scrollHeight, setScrollHeight] = useState(
        () => elementRef.current?.scrollHeight ?? 0
    );

    useEffect(() => {
        if (!enabled) {
            return;
        }

        const element = elementRef.current;
        if (!element) {
            return;
        }

        setScrollHeight(element.scrollHeight);

        const resizeObserver = new ResizeObserver((entries) => {
            const entry = entries[0];
            if (entry) {
                setScrollHeight(entry.target.scrollHeight);
            }
        });

        resizeObserver.observe(element);

        return () => {
            resizeObserver.disconnect();
        };
    }, [elementRef, enabled]);

    return enabled ? scrollHeight : elementRef.current?.scrollHeight ?? 0;
}
